// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export enum CtsGantryStepStatusEType {
  NOT_EXECUTED = 'not-executed',
  EXECUTED = 'executed',
  FAILED = 'failed',
  SUCCESSFUL = 'successful',
}
